import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/atoms/Button';
import { forgotPassword } from '@/services/auth';
import styles from './Login.module.scss';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
    } catch {
      // Aunque haya error, mostramos "enviado" — no leakeamos si el email existe.
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  }

  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <h1>Knooowy</h1>
        <p className={styles.subtitle}>Recupera tu contraseña</p>

        {sent ? (
          <>
            <p style={{ background: '#dcfce7', color: '#166534', padding: 12, borderRadius: 8, margin: '16px 0' }}>
              Si tu email está registrado, en breve recibirás un enlace para crear una contraseña nueva. Revisa también tu carpeta de spam.
            </p>
            <p style={{ textAlign: 'center', margin: '16px 0 0', fontSize: 14 }}>
              <Link to="/login" style={{ color: '#7047eb' }}>Volver al login</Link>
            </p>
          </>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form} noValidate>
            <p style={{ fontSize: 14, color: '#666', margin: '0 0 16px' }}>
              Introduce el email de tu cuenta y te enviaremos un enlace para restablecer la contraseña.
            </p>

            <label className={styles.field}>
              <span className={styles.label}>Email</span>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={styles.input}
              />
            </label>

            <Button type="submit" variant="primary" disabled={submitting}>
              {submitting ? 'Enviando…' : 'Enviar enlace'}
            </Button>

            <p style={{ textAlign: 'center', margin: '16px 0 0', fontSize: 14 }}>
              <Link to="/login" style={{ color: '#7047eb' }}>Volver al login</Link>
            </p>
          </form>
        )}
      </div>
    </main>
  );
}
